import React from "react";
import "./how.css";
import SwitchAccountIcon from "@mui/icons-material/SwitchAccount";
import HandshakeIcon from "@mui/icons-material/Handshake";
import ForumIcon from "@mui/icons-material/Forum";
import howImg from "../../Media/SCREENS.png";

const How = () => {
  return (
    <div className="how-view" id="how">
      <h1>How It Works</h1>
      <div className="how_content">
        <div className="how">
          <SwitchAccountIcon style={{ color: "#019561", fontSize: 50 }} />
          <p>You fulfil some assessments about your situation.</p>
        </div>
        <div className="how">
          <HandshakeIcon style={{ color: "#019561", fontSize: 50 }} />
          <p>You get directed to a channel where you share with others.</p>
        </div>
        <div className="how">
          <ForumIcon style={{ color: "#019561", fontSize: 50 }} />
          <p>You discuss your issues with others through texts and messages.</p>
        </div>
      </div>
      <div className="how_img">
        <h1>Chat and access therapy with others like you on all screens.</h1>
        <img src={howImg} alt="how-img" />
      </div>
    </div>
  );
};

export default How;
